/**
 * Collection Badge Component
 * Used in collection page blocks for consistent badge styling
 */

import {listedDiscountMeta,type ListedOfferEvidence} from '@/lib/badges/price-evidence'
import { BADGE_CONFIGS } from './config'

interface CollectionBadgeProps {
  type: 'trending' | 'featured' | 'value_pick' | 'seen_before' | 'brand' | 'popular_pick'
  brandName?: string // For brand badges
  listedOffer?:ListedOfferEvidence
  hasPriceDrop?: boolean
  originalPrice?: number
  price?: number
}

export function CollectionBadge({ 
  type, 
  brandName,
  listedOffer,
  hasPriceDrop,
  originalPrice,
  price 
}: CollectionBadgeProps) {
  // Priority: Price Drop overrides everything
  if (listedDiscountMeta(listedOffer,typeof price==='number'?Math.round(price*100):undefined)) {
    const config = BADGE_CONFIGS.price_drop
    return (
      <span className={`${config.bgColor} ${config.textColor} border ${config.borderColor} text-xs px-2 py-1 rounded font-medium shadow-sm`}>
        {config.emoji} {config.label}
      </span>
    )
  }
  
  // Show type-specific badge
  const configMap = {
    trending: BADGE_CONFIGS.trending,          // 🚀 Trending
    featured: BADGE_CONFIGS.premium,           // 💎 Featured
    value_pick: BADGE_CONFIGS.deal,            // 🎁 Value Pick
    seen_before: BADGE_CONFIGS.seen_before,    // 🔍 Seen Before
    popular_pick: BADGE_CONFIGS.best_seller,   // Popular Pick (no emoji)
    brand: { 
      emoji: '', 
      label: brandName || '', 
      bgColor: 'bg-blue-600', 
      textColor: 'text-white', 
      priority: 99,
      borderColor: undefined
    }
  }
  
  const config = configMap[type]
  const borderClass = config.borderColor ? `border ${config.borderColor}` : ''
  
  return (
    <span className={`${config.bgColor} ${config.textColor} ${borderClass} text-xs px-2 py-1 rounded font-medium shadow-sm`}>
      {config.emoji && <span>{config.emoji} </span>}
      {config.label}
    </span>
  )
}

